export const matchesStudioAmountFilter = (
  studioAmount: string | number | undefined,
  selectedStudioAmount: string
): boolean => {
  if (!selectedStudioAmount) return true

  let studioAmountNum: number | null = null

  if (typeof studioAmount === "number")
    studioAmountNum = studioAmount
  else if (studioAmount === null)
    studioAmountNum = null
  else
    studioAmountNum = Number(studioAmount)

  if (typeof studioAmountNum !== "number" || isNaN(studioAmountNum)) return false

  // Handle the case where selectedStudioAmount is higher than 3
  if (selectedStudioAmount === "3+")
    return studioAmountNum >= 4

  return studioAmountNum === Number(selectedStudioAmount)
}
